<template>
    <my-form 
    ref="form" 
    v-model="form" 
    table 
    label-width="160px"
    :submit-url="`${this.getGetters('mngUrl')}/tree/addzbr.json`"
    @cancle="cancleHandler"
    >
        <el-form-item 
            class="table-full-row"
            label="招标人营业执照代码" 
            prop="zbrcode" 
            :rules="[{validator:zbrCodeVal, trigger:['blur', 'change']}, {required:true,message:'必填', trigger:['blur', 'change']}]"
        >
            <el-input v-model="form.zbrcode"></el-input>
        </el-form-item>
        <el-form-item 
            class="table-full-row"
            label="招标人名称" 
            prop="zbrname" 
            :rules="newRule('招标人名称', 'required')"
        >
            <el-input v-model="form.zbrname"></el-input>
        </el-form-item>
        <el-form-item 
            class="table-full-row"
            label="招标人联系人" 
            prop="zbrlxr" 
            :rules="newRule('招标人联系人', 'required')"
        >
            <el-input v-model="form.zbrlxr" maxlength="15" show-word-limit></el-input>

        </el-form-item>
        <el-form-item 
            class="table-full-row"
            label="联系人电话" 
            prop="zbrlxdh" 
            :rules="newRule('联系人电话', 'required', 'mobile')"
        >
            <el-input v-model="form.zbrlxdh"></el-input>
        </el-form-item>
    </my-form>
</template>

<script>
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

export default {
    mixins: [DIALOG_FORM_PAGE_MIXIN],
    data: () => ({
        form: {
            zbrcode: '',
            zbrname: '',
            zbrlxr: '',
            zbrlxdh: ''
        }
    }),
    methods: {
        submitHandler() {
            this.$refs.form.onSubmit();
        },
        zbrCodeVal(rule, value, callback) {
            if(value === 'AAAAAA') {
                return callback();
            };
            return this.newRule('招标人营业执照代码', 'ucc')[0].validator(rule, value, callback);
        }
    }
}
</script>

<style>

</style>